export default "__VITE_ASSET__quMNWJXU__"